<template lang="pug">
div
  app-aviso-notificacao(
    v-if="showAvisoNotificacao"
    :conversasAbertas="conversaAberta"
    @prolongado="carregarConversas"
    :prolongado="conversaAberta[0].prolongado"
  )
  app-lista-conversas(
    :loading="loading",
  )
    app-paginacao(
      :total="totalConversas || 0",
      :pagina="pagina",
      :tamanhoPagina="10",
      @changePage="changePage"
    )
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import vuex from '../../../../store'
import AppDividerRefreshButton from '../../../../components/AppDividerRefreshButton'
import AppListaConversas from '../centralMensagens/AppListaConversas'
import AppPaginacao from '../../../../components/AppPaginacao'
import AppAvisoNotificacao from './AppAvisoNotificacao'
const { isConversaPassivelDeArquivamento } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppDividerRefreshButton,
    AppListaConversas,
    AppPaginacao,
    AppAvisoNotificacao
  },

  data () {
    return {
      pagina: 1,
      totalConversas: 0,
      show: '',
      tipoMensagem: [
        {
          codigo: 'ENVIADA',
          label: 'Não Lidas'
        },
        {
          codigo: 'LIDA',
          label: 'Lidas'
        },
        {
          codigo: 'TODAS',
          label: 'Todas'
        }
      ],
      isConversaPassivelDeArquivamento: isConversaPassivelDeArquivamento
    }
  },

  mounted () {
    this.carregarConversas()
  },

  computed: {
    ...mapState({
      loading: state => state.loader.status
    }),

    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),

    conversa () {
      return this.$store.getters[`conversas/conversas${this.tipo}`]
    },

    conversaAberta () {
      return this.conversa?.list?.content?.filter(c => c.status === 'ABERTA')
    },

    tipo () {
      return this.$store.getters['conversas/tipo']
    },

    showAvisoNotificacao () {
      return this.conversaAberta && this.conversaAberta.length > 0 && this.isConversaPassivelDeArquivamento(this.conversaAberta[0].tipo)
    }
  },

  methods: {

    ...mapActions({
      findConversasProcesso: 'conversas/findConversasProcesso'
    }),

    changePage (newPage) {
      this.pagina = newPage
      this.carregarConversas()
    },

    async carregarConversas () {
      vuex.commit('conversas/SET_CONVERSAS_TIPO', 'Processo')
      if (this.tipo === 'Processo') {
        await vuex.dispatch('conversas/findConversasProcesso', {
          protocoloProcesso: this.$route.params.idCadastro,
          pagina: this.pagina - 1,
          tipoMensagem: this.show,
          idUsuario: this.usuario.id,
          isCentralInteressado: true
        })
        this.totalConversas = this.conversa.list.totalElements
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .alinhamento {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/screens/central/components/centralMensagens/AppCentralMensagens.vue